import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { LoginServiceService } from 'src/app/services/api/login-service.service';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgpt-password',
  templateUrl: './forgpt-password.component.html',
  styleUrls: ['./forgpt-password.component.scss']
})
export class ForgptPasswordComponent implements OnInit {

  constructor(private router: Router,private _loginService : LoginServiceService, private _snackbarService : SnackBarService) { }

  username: string;
  password: string;
  Checked : boolean = false;
  RememberMe : boolean = false;
  errorMessage = '';
  passwordType = 'password';
  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
  
  });
  ngOnInit( ): void {
  }
 
  login(e) {
    console.log(e);
    var PersonObj = {
      UserName : e.username,
      ClientUri : environment.resetPassword
    }
    this._loginService.ForgetPassword(PersonObj).subscribe((res) => {
        console.log(res);
        const options = {
          title: 'Succesful',
          message: 'Password link is sent to your mail.',
          cancelText: 'Ok',
          //confirmText: 'Confirm'
        };
        this._snackbarService.open(options);
    },
    (err) => {
      console.log(err);
      const options = {
        title: 'Failed',
        message: 'Failed,Please try again',
        cancelText: 'Ok',
        //confirmText: 'Confirm'
      };
      this._snackbarService.open(options);

    })
  }

}
